import React from 'react';

// Final CTA strip near the bottom of HomePage. Phone + email use
// fixed values, the headline + subtitle are admin-editable via
// storefront settings.
export default function HomepageCta({ settings }) {
  return (
    <section className="asg-cta" id="contact">
      <div className="asg-cta-content asg-reveal">
        <h2 className="asg-cta-title">{settings.cta_title ?? 'Prefer to talk?'}</h2>
        <p className="asg-cta-sub">{settings.cta_subtitle ?? "Call us directly or send an email - we'd love to hear about your project."}</p>
        <div className="asg-cta-buttons">
          <a href="#quote" className="asg-btn-primary-dark">Request a Quote</a>
          <a href="tel:+61422439499" className="asg-btn-ghost-dark">Call +61 422 439 499</a>
          <a href="mailto:info@asgshading.com.au" className="asg-btn-ghost-dark">Email Us</a>
        </div>
      </div>
    </section>
  );
}
